// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"5eec1097","154":"85008109","562":"fd0a0725","613":"da51bb40","619":"a77a2e94","622":"d86944f4","741":"f5bc35f7","821":"5cc5a923","920":"77844a4f"}[chunkId] + ".chunk.css";
};